import { Record } from "immutable";

export class CaseNoteRecord extends Record({
    id: null,
    user: null,
    case: null,
    stage: null,
    reference: null,
    notes: null,
    create_date: null,
    state_status: null,
    create_date_string: null,
    is_active: null
}) {
    get formValues() {
        return this.toSeq()
            .toMap()
            .filter((v, k) => !["state_status"].includes(k))
            .set("stage", this.stage && this.stage.id)
            .set("user", this.user && this.user.id)
            .toJS();
    }
}
